<form [formGroup]="optionSetForm()" class="options-library-form">
  <div class="options-library-form__field">
    <span class="label fs__md">Option Set Name</span>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="options-library-form__field__input">
      <input matInput formControlName="name" type="text" placeholder="e.g, Purchase intent scale, Brand preference list" aria-label="Option Set Name" />
    </mat-form-field>
  </div>

  <div class="options-library-form__field">
    <span class="label fs__md">Description</span>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="options-library-form__field__input">
      <input matInput formControlName="description" type="text" placeholder="Add Description" aria-label="Description" />
    </mat-form-field>
  </div>

  <div class="options-library-form__field">
    <span class="label fs__md">Options</span>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="options-library-form__field__textarea">
      <textarea
        matInput
        formControlName="options"
        autocomplete="off"
        [rows]="6"
        [required]="true"
        placeholder="Enter each option on a new line:
      Definitely
      Probably
      Maybe
      Probably not
      Definitely not"
      ></textarea>
    </mat-form-field>
  </div>

  <button mat-flat-button color="primary" [disabled]="!optionSetForm().valid" (click)="isEdit$() ? edit.emit() : create.emit()">
    <span class="fs__sm fw__500">{{ isEdit$() ? 'Edit Option Set' : 'Create Option Set' }}</span>
  </button>
</form>
